import LinearProgress from '@material-ui/core/LinearProgress';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import * as React from 'react';
import { connect } from 'react-redux';
import { IState } from '../../ducks';
import { Banner } from '../Banner';
import { UploadActivityDialog } from './UploadActivityDialog';

interface IUploadBannerProps {}

interface IUploadBannerState {
  showDialog: boolean;
}

interface IReduxProps {
  failCount: number;
  fileCount: number;
  percent: number;
}

type UploadBannerProps = IUploadBannerProps & IReduxProps;
class UploadBannerComponent extends React.Component<UploadBannerProps, IUploadBannerState> {
  readonly state: IUploadBannerState = {
    showDialog: false
  };

  hideDialog = () => this.setState({ ...this.state, showDialog: false });
  showDialog = () => this.setState({ ...this.state, showDialog: true });
  filePluralString = (count: number): string => (count > 1 ? 'files' : 'file');
  getText = (): string => {
    const { fileCount, percent, failCount } = this.props;

    if (failCount > 0) {
      return `${failCount} ${this.filePluralString(failCount)} failed to upload. Click the button view details.`;
    }

    if (fileCount === 0) {
      return 'Upload Complete';
    }

    return `Uploading ${fileCount} ${this.filePluralString(fileCount)} - ${percent.toFixed(2)}%`;
  };

  render(): JSX.Element {
    const { failCount, fileCount, percent } = this.props;
    const { showDialog } = this.state;

    return (
      <>
        <Banner
          visible={fileCount > 0 || failCount > 0}
          text={this.getText()}
          buttonText="View"
          onButtonClick={this.showDialog}
          icon={failCount > 0 ? ErrorIcon : undefined}
        >
          {fileCount > 0 && <LinearProgress color="secondary" variant="determinate" value={percent} />}
        </Banner>
        {showDialog && <UploadActivityDialog onClose={this.hideDialog} />}
      </>
    );
  }
}

function mapStateToProps(state: IState): IReduxProps {
  const values = Object.values(state.files.uploads.progress);
  return {
    failCount: state.files.uploads.failed.length,
    fileCount: values.length,
    percent: (values.reduce((sum, next) => (sum += next), 0) / values.length) * 100
  };
}

export const UploadBanner = connect(mapStateToProps)(UploadBannerComponent);
